import React from "react";
import heroIllustration from "../../../../assets/images/hero-illustration.webp";
export default function Hero() {
  return (
    <header className="hero-section" style={{background: `white`}}>
      <div className="container-selectezi">
        <div className="row align-items-center g-5">
          <div className="col-lg-6">
            <button
              type="button"
              className="btn-selectezi-primary mb-4"
              disabled
            >
            Hire Marketing Agent
            </button>

  <h1 className="hero-heading mt-3 text-dark">
  Hire A Marketing Agent To Promote Your Business Faster
  <br />
  <span className="accent">
    Excellent Support For Your Business Publicity
  </span>
</h1>

            <p className="lead-copy mt-4">
              A SELECTEZI Marketing Agent helps businesses, shops, service
              providers and product owners increase visibility, promote
              their offerings and connect with potential customers and
              business opportunities across their selected region.
            </p>

            <a href="#how-it-works" className="btn-selectezi-primary mt-4">
              How It Works
              <i className="bi bi-arrow-down" />
            </a>
          </div>

          <div className="col-lg-6">
            <div className="hero-art-panel">
              <img src={heroIllustration} alt="SELECTEZI Marketing Agent promoting a business" />
            </div>
          </div>
        </div>
      </div>
    </header>
  );
}
